import { useMemo } from 'react';
import InteractiveButton from '../../../../../../../InteractiveButton/InteractiveButton';
import { ACTIVE_TAB_STYLES, COMMON_TAB_STYLES, INACTIVE_TAB_STYLES } from './constants';

export interface TabButtonProps {
  onClick?: () => void;
  isActive?: boolean;
  text?: string;
}

export const Button = ({ onClick, isActive, text }: TabButtonProps) => {
  const customType = useMemo(() => {
    if (isActive) {
      return ACTIVE_TAB_STYLES;
    }

    return INACTIVE_TAB_STYLES;
  }, [isActive]);

  return (
    <InteractiveButton onClick={onClick} customType={`${COMMON_TAB_STYLES} ${customType}`} style={{ padding: '4px' }}>
      {text}
    </InteractiveButton>
  );
};
